import get from 'lodash/get';
import { alerts } from '../actionTypes/alerts.js';

const startFetchingAlertSummaryData = () => ({
  type: alerts.START_FETCHING_ALERT_SUMMARY_DATA
});

const successFetchingAlertSummaryData = payload => ({
  type: alerts.SUCCESS_FETCHING_ALERT_SUMMARY_DATA,
  payload
});

const errorFetchingAlertSummaryData = payload => ({
  type: alerts.FAILURE_FETCHING_ALERT_SUMMARY_DATA,
  payload
});

export const clearAlertSummaryData = () => ({
  type: alerts.CLEAR_ALERT_SUMMARY_DATA
});

export const fetchAlertSummaryDataByType = filters => (dispatch, getState) => {

  dispatch(clearAlertSummaryData());
  dispatch(startFetchingAlertSummaryData());

  const { field_name, direction } = getState().sortReducer;

  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic',
      method: 'POST',
      body: {
        data_tag: 'DATATAG_DELIGHTIQ_ALERT_SUMMARY_BY_TYPE',
        request_data: {
          sort: {
            field_name,
            direction
          },
          filters
        }
      }
    },

    onSuccess: ({ data }) => {
      const alerts_summary_data = get(
        data,
        'data.api_response.APITAG_DELIGHTIQ_ALERT_SUMMARY_BY_TYPE.data',
        []
      );

      dispatch(
        successFetchingAlertSummaryData({ alerts_summary_data })
      );
    },

    onError: ({ error }) => {
      dispatch(errorFetchingAlertSummaryData({ error }));
    }
  });
};
